module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANAQMAAABIJXY/AAAABlBMVEX///+3t7drUiW7AAAAAXRSTlMAQObYZgAAAB5JREFUeJxjYEAF9R8Y7B8wyB9g4G9gYGdgYIIKAwBLegQGSIOTzwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/arrow-asc.png
// module id = 191
// module chunks = 0